import React from "react";
import * as styles from "./MenuLangingPage.module.scss";
import { Logo } from "@silversea-ssc/ui-components-react";
import { legacyUrl } from "src/ab-test-experiments/paths";
import TopNavLink from "./MegaMenu/TopMenu/TopNav/TopNavLink";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import ExperimentalPhoneNumber from "./MegaMenu/PhoneNumber/ExperimentalPhoneNumber";
import clsx from "clsx";
import { ValidatedTopMenuItem } from "./MegaMenu/utils";

type Props = {
  topLinks: ValidatedTopMenuItem[];
  showLinksOnMobile?: boolean;
};

const MenuLangingPage: React.FC<Props> = ({ topLinks, showLinksOnMobile }) => {
  const language = useLanguage();

  return (
    <nav
      className={clsx(styles.header, {
        [styles.showLinksOnMobile]: showLinksOnMobile
      })}
      aria-label="Menu"
    >
      <div className={styles.headerContainer}>
        <div className={styles.brandLogo}>
          <a
            href={legacyUrl(`/${language.path}`)}
            style={{ display: "block" }}
            data-content-piece="logo"
          >
            <Logo width={180} mobileWidth={180} />
          </a>
        </div>
        <div className={styles.phone}>
          <ExperimentalPhoneNumber />
        </div>
        <nav
          aria-label="Secondary menu"
          data-content-piece="secondary_menu"
          className={styles.secondaryNavItems}
        >
          {topLinks && topLinks.length > 0 && (
            <ul>
              <React.Fragment>
                {topLinks.map((l) => (
                  <li key={l._key}>
                    <TopNavLink {...l} renderAs="link" />
                  </li>
                ))}
              </React.Fragment>
            </ul>
          )}
        </nav>
      </div>
    </nav>
  );
};

export default MenuLangingPage;
